
<p-dialog [(visible)]="display" (onHide)="onDialogHide()">

	<p-header>
		Confirm
	</p-header>

	<p>{{message}}</p>

    <p-footer>
		<button type="button" pButton icon="fa fa-check" (click)="onYesClicked()" label="Yes"></button>
        <button type="button" pButton icon="fa fa-close" (click)="onNoClicked()" label="No"></button>
    </p-footer>

</p-dialog>
